/**
 * Subscription API client (Phase 3 — Drive-First Pivot).
 *
 * Customer self-service endpoints under /api/subscriptions/me/.
 */

import { apiService } from './api'

export const subscriptionAPI = {
  // Current workspace subscription state
  me: () => apiService.get('/subscriptions/me/'),

  // Create Stripe Checkout Session — returns { checkout_url, session_id }
  checkout: (opts = {}) => apiService.post('/subscriptions/me/checkout/', opts),

  // Stripe billing portal URL — returns { portal_url }
  billingPortal: () => apiService.get('/subscriptions/me/billing/'),

  // Cancel (defaults to at_period_end=true)
  cancel: ({ at_period_end = true, reason = '' } = {}) =>
    apiService.post('/subscriptions/me/cancel/', { at_period_end, reason }),

  // Un-cancel a pending cancellation
  reactivate: () => apiService.post('/subscriptions/me/reactivate/'),

  // Lifecycle audit log
  events: () => apiService.get('/subscriptions/me/events/'),
}

export const onboardingAPI = {
  status: () => apiService.get('/onboarding/status/'),
  skip: () => apiService.post('/onboarding/skip/'),
}

export default subscriptionAPI
